/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260428
    
*/
'use strict';

import {
    bindSelect,
    getMoveIcon,
    getTableRows
} from './ctssHtml.js';
import {
    hasImgsToUpload,
    initImgCtrl,
    uploadImgToCloudAsync
} from './ctssImg.js';
import {
    allSettled,
    deletePromise,
    getPromise,
    getSortKeysFromTableOrder,
    initDragDropTableSort,
    savePromise
} from './ctssJQuery.js';
import { initSearch } from './ctssSearchDlg.js';
import {
    isDataModified,
    missingRequiredData,
    setModified
} from './ctssVal.js';
import {
    getGroupsToolBarDataAsync,
    initGroupsDDL,
    initGroupsToolBar
} from './snGroupCtrls.js'
import {
    getGroupLeadersAsync,
    saveGroupLeaderAsync
} from './snGroupLeaders.js'
import {
    approveJoinRequestAsync,
    getGroupMembersAsync,
    getJoinRequestAsync,
    leaveAsync,
    saveGroupMembersAsync
} from './snGroupMembers.js';
import {
    getMemberImgsBaseURLAsync,
    getMemberSearchDataAsync
} from './snMembers.js';
import {
    appDebugMode,
    ImgsFolder,
    getAppToken,
    getImgsBaseURLAsync,
    getTestFolderParams,
    setMenu
} from './snSite.js';

const { useTestFolder, testFolderParam } = getTestFolderParams();

const token = getAppToken();

const deleteGroupAsync = async (params) => {
    await deletePromise({
        url: `Groups/${token.CG}/${params.groupID}`,
    }).then(() => {
        /* splice returns array of deleted elements so we take first and only one [0] */
        const g = groups.splice(groups.findIndex(x => x.id === params.groupID), 1)[0];
        g.daysBeforeDeletion = 30;
        deletedGroups.push(g);
        setBtnRestoreGroupVisibility();
        $(`#gridGroups>tbody>tr[id="${params.groupID}"]`).remove();
        $('#deleteDlg').modal('hide');
    })
}

const deleteGroupMemberAsync = async (params) => {

    await leaveAsync(params)
        .then(() => {
            //groupMembers.splice(groupMembers.findIndex(x => x.id === parseInt(params.memberID, 10)), 1);
            $('#' + params.memberID).remove();
            $('#deleteDlg').modal('hide');
        });
}

const getCurrentGroupLeaders = (groupID) => {

    /* Retrieves data for leaders grid on updateDlg when adding or editing group data. *
     * Newly added or removed group leaders are held in memory and saved with group    *
     * data as a batch so that any change can be reversed with updateDlg cancel button */

    const currentGroupLeaders = groupLeaders.filter(gl => gl.groupID === groupID);

    if (groupLeadersToAdd.hasOwnProperty('leaderStatuses')) {
        groupLeadersToAdd.leaderStatuses.forEach(newLeader => {
            const leaderData = churchMembers.find(x => x.id === newLeader.memberID);
            currentGroupLeaders.push({
                groupID: groupID,
                id: newLeader.memberID,
                mg: leaderData.mg,
                firstName: leaderData.firstName,
                lastName: leaderData.lastName,
                name: leaderData.name,
                email: leaderData.email,
                phone: leaderData.phone,
                imgName: leaderData.imgName
            });
        });
    };

    if (groupLeadersToRemove.length > 0) {
        groupLeadersToRemove.forEach(glToRemove => {
            currentGroupLeaders.splice(
                currentGroupLeaders.findIndex(x => x.id === glToRemove.memberID),
                1);
        });
    }
    return currentGroupLeaders;
}

const getGroupAccessLevelsDDLDataAsync = async () =>
    await getPromise({ url: 'Groups/AccessLevels' });

const getChurchGroupData = async () =>
    await getPromise({ url: `Churches/${token.CG}/Group` });

const getGroupDataAsync = async (params) =>
    await getPromise({ url: `Groups/${token.CG}/${params.groupID}` });

const getGroupDefaultImgNmAsync = async () =>
    await getPromise({ url: 'Groups/DefaultImgNm' })

const getGroupsDataAsync = async () => {

    const leaderMG = token.GroupLeaderRights.length > 0
        ? `?mg=${token.sub}`
        : '';

    return await getPromise({
        url: `Groups/${token.CG}${leaderMG}`
    });

}

const getGroupsQueryParam = (params = {}) => {

    const {
        groups,
        isAdmin,
        queryOperator = '?'
    } = params;

    if (!groups || isAdmin === "True") {
        return '';
    }

    const gids = groups
        .filter(x => x.value !== '-1')
        .map(x => x.value)
        .join(',');

    return gids.length > 0 ? `${queryOperator}gids="${gids}"` : '';
    
}

const getGroupRow = (params) => {

    const trClass = params.data.id === "0"
        ? ' class="no-sort" '
        : '';

    let row = `<tr id="${params.data.id}" data-displayOrder="${params.data.displayOrder}" ${trClass}>` +
        `<td class="col-md-3 imgDesc-circle-sm"><img class="grpImg" data-img_name="${params.data.imgName}" src="${groupImgsBaseURL}${params.data.imgName}"><span>${params.data.name}</span></td>`;

    const leaders = groupLeaders.filter(gl => gl.groupID === params.data.id);
    if (leaders.length > 0) {
        let leaderRows = '';
        leaders.forEach(l => {
            leaderRows += `<tr><td class="col-md-3 col-no-gutter imgDesc-circle-sm"><img src="${memberImgsBaseURL}${l.imgName}"><span>${l.name}</span></td>` +
                `<td class="col-md-3">Email: ${l.email}</br>Phone: ${l.phone}</td></tr>`
        });
        row += `<td class="col-md-6"><table><tbody>${leaderRows}</tbody></table></td>`
    } else {
        row += '<td class="col-md-6"></td>'
    }

    let icons = '<table class="h-icon-toolbar"><tbody><tr>';
    icons += `<td><div><span class="fa fa-pencil" title="Edit group..." data-toggle="modal" data-target="#updateDlg" data-key="${params.data.id}"></span></div></td>`;

    if (params.data.id === "0") {/*View members, approve membership, delete or move is not allowed for default group */
        icons += '<td><div></div></td><td><div></div></td><td><div></div></td><td><div></div></td>'
    } else {
        icons += `<td><div><span class="fa fa-users" title="View members..." data-toggle="modal" data-target="#listDlg" data-key="${params.data.id}"></span></div></td>`;
        icons += params.data.access === 1
            ? `<td><div><span class="fa fa-user-plus" title="Approve membership..." data-toggle="modal" data-target="#joinRequestDlg" data-key="${params.data.id}"></span></div></td>`
            : '<td><div></div></td>';
        icons += '<td><div><span class="fa fa-trash" title="Delete group..." data-toggle="modal" data-target="#deleteDlg" ' +
            `data-caller="group" data-key="${params.data.id}" ></span></div></td >` +
            `<td><div>${getMoveIcon()}</div></td>`;
    }

    icons += '</tr></tbody></table>';

    const access = params.data.access === 0
        ? 'Public'
        : params.data.access === 1 ? 'Private' : 'Hidden'

    row += '<td class="col-md-3"><div class="ib">' + access + '</div>' + icons + '</td></tr>';

    return row;
}

const getGroupLeaderRow = (params) => {
    return `<tr id="${params.data.id}">` +
        `<td class="col-sm-3 imgDesc-circle-sm"><img src="${memberImgsBaseURL}${params.data.imgName}"><span>${params.data.name}</span></td>` +
        `<td class="col-sm-3">Email: ${params.data.email}</br>Phone: ${params.data.phone}</td>` +
        '<td class="col-sm-2 text-right">' +
        '<span class="fa fa-trash mRight10" title="Remove as leader..." data-toggle="modal" data-target="#deleteDlg" ' +
        `data-caller="leader" data-groupID="${groupID}" data-key="${params.data.id}" ></span>` +
        '</td></tr>';
}

const getGroupMemberRow = (params) => {
    const isLeader = params.data.isLeader ? '<span class="fa fa-check"></span>' : '';
    return `<tr id="${params.data.id}">` +
        `<td class="col-sm-3">${params.data.name}</td>` +
        `<td class="col-sm-3">${params.data.email}</td>` +
        `<td class="col-sm-2">${params.data.phone}</td>` +
        `<td class="col-sm-1 text-center">${isLeader}</td>` +
        '<td class="col-sm-2 text-right">' +
        '<span class="fa fa-trash mRight10" title="Delete member..." data-toggle="modal" data-target="#deleteDlg" ' +
        `data-caller="member" data-groupID="${groupID}" data-key="${params.data.id}" data-name="${params.data.name}" ></span>` +
        '</td></tr>';
}

const getGroupName = (groupID) => groups[groups.findIndex(x => x.id === groupID)].name;

const getJoinRequestRow = (params) => {
    return `<tr id="${params.data.id}">` +
        `<td class="col-sm-1"><input id="${params.data.mg}" type="checkbox" class="k-checkbox">` +
        `<label for="${params.data.mg}" class="k-checkbox-label"></label></td>` +
        `<td class="col-sm-3">${params.data.name}</td>` +
        `<td class="col-sm-3">${params.data.email}</td>` +
        `<td class="col-sm-3">${params.data.phone}</td>` +
        `<td class="col-sm-2 text-right">${params.data.joinRequestDate}</td></tr>`;
}

const initConfirmDlg = () => {
    $('#confirmDlg').on('show.bs.modal', (e) => {
        const action = e.relatedTarget.dataset.caller === "btnApproveApplicant" ? "allow" : "deny";
        const group = groups[groups.findIndex(x => x.id === groupID)];
        $('#confirmPrompt').text(`Are you sure you want to ${action} selected applicants membership to ${group.name}?`)
        $('#btnConfirm').off('click').on('click', async () => {
            if (action === "allow" || action === "deny") {
                const isApproved = action === "allow";
                const approvalKeys = [];
                const selected = $('#gridJoinRequests > tbody input:checked');
                for (let i = 0, l = selected.length; i < l; i++) {
                    approvalKeys.push({
                        mg: selected[i].id,
                        isApproved: isApproved
                    });
                }
                const p = {
                    groupID: groupID,
                    groupName: group.name,
                    approvalKeys: approvalKeys
                };
                if (action === "deny") {
                    p.leader = {                       /* Used when sending denial notification */
                        name: group.leader.name,
                        email: group.leader.email,
                        phone: group.leader.phone
                    };
                }
                //console.log('btnConfirm params', p);      
                await approveJoinRequestAsync({
                    btnId: action === "allow" ? "btnApproveApplicant" : "btnDenyApplicant",
                    data: p,
                    divErrMsg: 'divJoinRequestDlgErrMsg'
                }).then(async () => {
                    try {
                        const data = await getJoinRequestAsync({ groupID });
                        refreshJoinRequestGrid({ data });
                        $('#confirmDlg').modal('hide');
                    }
                    catch (error) { }
                });
            }
        });
    })
}

const initDeleteDlg = () => {
    $('#deleteDlg').on('show.bs.modal', (e) => {

        $('#btnDeleteCancel').html('No');
        $('#btnDelete').removeClass('hidden');

        const caller = e.relatedTarget.dataset.caller,
            key = e.relatedTarget.dataset.key,
            groupid = e.relatedTarget.dataset.groupid;

        let name, prompt;
        if (caller === 'group') {
            name = groups[groups.findIndex(x => x.id === key)].name;
            prompt = `Are you sure you want to delete the ${name} group?`;
        } else if (caller === 'leader') {

            const currentGroupLeaders = getCurrentGroupLeaders(groupid);
            name = currentGroupLeaders[currentGroupLeaders.findIndex(x => x.id === key)].name;

            if (currentGroupLeaders.length === 1) {
                prompt = `${name} is the only group leader.  Please edit the group and choose another leader before removing ${name} from the group...`;
                $('#btnDeleteCancel').html('OK');
                $('#btnDelete').addClass('hidden');
            } else {
                prompt = `Are you sure you want to remove ${name} as a group leader?`
            }

        } else if (caller === 'member') {
            name = e.relatedTarget.dataset.name;
            prompt = `Are you sure you want to remove ${name} from the group?`;
        } else {
            prompt = 'Unknown caller - Please contact support@ctsoftwaresystems.com...'
            $('#btnDeleteCancel').html('OK');
            $('#btnDelete').addClass('hidden');
        }

        $('#deletePrompt').text(prompt);
        $('#btnDelete').off('click').click(async () => {
            if (caller === 'group') {
                await deleteGroupAsync({ groupID: key });
            }
            else if (caller === 'leader') {
                groupLeadersToRemove.push({ memberID: key, isLeader: false });
                refreshGroupLeadersGrid({ groupID: groupid });
                $('#deleteDlg').modal('hide');
            }
            else if (caller === 'member') {
                await deleteGroupMemberAsync({ groupID: groupid, memberID: key });
            }
        });
    });
}

const initDlg_DDL = () => {
    $('#ddlDlg').on('show.bs.modal', (e) => {
        const caller = e.relatedTarget.dataset.caller,
            hasImages = e.relatedTarget.dataset.has_images;

        if (hasImages) {
            $('#divImagesDDL').removeClass('hidden');
        } else {
            $('#divDDL').removeClass('hidden');
        }
        if (caller === 'restore_group') {
            $('#ddlDlgLbl').text('Please restore the following group...');
            if (deletedGroups.length === 1) {
                const g = deletedGroups[0];
                $('#imagesDDL_Value').val(g.id);
                $('#btnImagesDDL').html(`Restore<img src="${groupImgsBaseURL}${g.imgName}" width="20"> ${g.name}<span class="daysLeft">${g.daysBeforeDeletion} days <span class="caret"></span></span>`);
                $('#divImagesDDL .dropdown-menu').addClass('hidden');
            } else {
                $('#btnImagesDDL').html('Select group to restore <span class="caret"></span>');
                let content = '';
                deletedGroups.forEach(g => {
                    content += `<li data-group_id="${g.id}" class="dropdown-item">` +
                        `<img src="${groupImgsBaseURL}${g.imgName}" width="20" data-group_id="${g.id}">${g.name}<span class="daysLeft">${g.daysBeforeDeletion} days</span></li>`
                });
                $('#divImagesDDL .dropdown-menu').removeClass('hidden').empty().append(content);
                $('#divImagesDDL .dropdown-menu > li').off('click').click(e => {
                    const g = deletedGroups[deletedGroups.findIndex(x => x.id === e.target.dataset.group_id)];
                    $('#imagesDDL_Value').val(g.id);
                    $('#btnImagesDDL').html(`Restore<img src="${groupImgsBaseURL}${g.imgName}" width="20">${g.name}<span class="daysLeft">${g.daysBeforeDeletion} days <span class="caret"></span></span>`);
                });
            }
            $('#btn_ddl_OK').off('click').click(async () => await restoreGroupAsync({ groupID: $('#imagesDDL_Value').val() }));
        }
    });
}

const initJoinRequestDlg = () => {
    $('#joinRequestDlg').on('show.bs.modal', async(e) => {
        groupID = e.relatedTarget.dataset.key;
        $('#listDlgLbl').text(`Applicants for ${getGroupName(groupID)}...`);

        try {
            const data = await getJoinRequestAsync({ groupID });
            refreshJoinRequestGrid({ data });
            $('#gridJoinRequests > tbody input[type="checkbox"]').off('click').on('click', () => {
                /* At least one applicant must be checked before action can be taken */
                $('#btnApproveApplicant,#btnDenyApplicant')
                    .prop('disabled', $('#gridJoinRequests > tbody input:checked').length === 0);
            });

        }
        catch (error) { }
    });
    $('#cbJoinHdr').off('click').on('click', function () {
        const isChecked = $(this).is(':checked');
        $('#gridJoinRequests > tbody input[type="checkbox"]').prop('checked', isChecked);
        $('#btnApproveApplicant,#btnDenyApplicant').prop('disabled', isChecked === false);

    });
}

const initMembersDlg = () => {
    $('#listDlg .modal-dialog').removeClass('w600').addClass('w800');
    const gridHeader = '<tr><th class="col-sm-3">Name</th>' +
        '<th class="col-sm-4">Email</th>' +
        '<th class="col-sm-2">Phone</th>' +
        '<th class="col-sm-1">Leader</th>' +
        '<th class="col-sm-2">' +
        '<div class="pull-right">' +
        '<button id="btnAddMember" class="btn btn-sm pull-right" ' +
        ' data-toggle="modal" data-target="#searchDlg" data-caller="add-member" ' +
        ' <span class="fa fa-plus"></span> Add Member</button>' +
        '</div>' +
        '</th></tr>';
    $('#gridList thead').empty().append(gridHeader);
    $('#listDlg').on('show.bs.modal', async (e) => {

        groupID = e.relatedTarget.dataset.key;
        $('#listDlgLbl').text(`${getGroupName(groupID)} members...`);

        try {
            const members = await getGroupMembersAsync({ groupID });
            refreshGroupMembersGrid({ members });
        }
        catch (error) { }
    });
}

const initSearchDlg = () => {

    $('#searchDlg').on('show.bs.modal', async (e) => {

        $('#searchTags').tagsinput('removeAll');
        $('#divSearchTags').addClass('hidden');

        const caller = e.relatedTarget.dataset.caller

        let selectItems;
        if (caller === 'add-member') {
            //groupMembers.push({ Name: 'Alan Whitmore' });
            try {
                const members = await getGroupMembersAsync({ groupID });
                selectItems = churchMembers
                    .filter(cm => members.findIndex(gm => gm.name === cm.name) === -1)
                    .map(m => ({ isSelected: false, id: m.id, name: m.name, email: m.email })); /* Extra () needed to return map object with properties instead of value */
            }
            catch (error) { }
        }
        else if (caller === 'add-leader') {
            /* search excluding existing current group leaders */

            const leaders = groupLeaders.filter(gl => gl.groupID === groupID)
            selectItems =
                churchMembers.filter(cm => leaders.findIndex(gl => gl.name === cm.name) === -1)
                    .map(m => ({ isSelected: false, id: m.id, name: m.name, email: m.email })); /* Extra () needed to return map object with properties instead of value */
        }

        const searchItems = selectItems.map(m => `${m.name} ${m.email}`);

        if (appDebugMode) {
            console.log('selectItems', selectItems);
            console.log('searchItems', searchItems);
        }

        // Don't know why fnSource can't be defined as anonymous function 

        const searchAutoCompleteSourceFilter = (term) => {
            const tags = $('#searchTags').val().toLowerCase();
            const items = searchItems.filter(item => {
                // filters for searchText at start of each work - either first word or char after space indicating next word.
                const text = item.toLowerCase();
                const searchText = term.toLowerCase();
                //console.log(`text ${text} searchtext ${searchText} include ${text.indexOf(searchText) === 0 || text.indexOf(` ${searchText}`) > -1}`)
                return tags.indexOf(text) === -1 && (text.indexOf(searchText) === 0 || text.indexOf(` ${searchText}`) > -1);
            });
            return items;
        }

        initSearch({
            fnSource: (request, response) => { response(searchAutoCompleteSourceFilter(request.term)) },
            fnSelect: (event, ui) => {
                /* remove email suffix from selected string */
                const idxLastSpace = ui.item.value.lastIndexOf(' ');
                const nm = ui.item.value.substring(0, idxLastSpace);
                $('#searchTags').tagsinput('add', nm);
                selectItems[selectItems.findIndex(i => i.name === nm)].isSelected = true;
                return false;
            },
            fnBeforeRemoveTag: (event) => {
                selectItems[selectItems.findIndex(i => i.name === event.item)].isSelected = false;
            }
        });


        const drawSelectRows = () => {
            let rows = '';
            selectItems.forEach(m => { /* If selected check modify */
                const checked = m.isSelected === true ? 'checked' : '';
                rows += '<tr>' +
                    `<td class="col-sm-2"><input id="cb_${m.id}" type="checkbox" class="k-checkbox cbSelectRow" ${checked} ><label for="cb_${m.id}" class="k-checkbox-label" /></td>` +
                    `<td class="col-sm-5">${m.name}</td>` +
                    `<td class="col-sm-5">${m.email}</td>` +
                    '</tr>';
            });
            $('#gridSelect tbody').empty().append(rows);
        }

        $('#btnShowSelectList').off('click').click(() => {
            $('#gridSelectHdrCol1').text('Name');
            $('#gridSelectHdrCol2').text('Email');
            drawSelectRows();

            $('#cbAll').off('click').click(() => {
                const isChecked = $('#cbAll').is(':checked');
                selectItems.forEach(x => {
                    x.isSelected = isChecked
                    if (isChecked) {
                        $('#searchTags').tagsinput('add', x.name);
                    }
                });
                drawSelectRows();
                if (isChecked === false) {
                    $('#searchTags').tagsinput('removeAll');
                }
            });

            $('.cbSelectRow').off('click').click((e) => {
                const cb_id = e.target.id,
                    id = cb_id.substring(3),
                    isChecked = $(`#${cb_id}`).is(':checked');
                const idx = selectItems.findIndex(x => x.id === id);
                selectItems[idx].isSelected = isChecked;
                if (isChecked) {
                    $('#searchTags').tagsinput('add', selectItems[idx].name);
                } else {
                    $('#searchTags').tagsinput('remove', selectItems[idx].name);
                }
            });

            $('#divSearch').addClass('hidden');
            $('#divSelectList').removeClass('hidden');
        });

        $('#btnSearchOK').off('click').click(async () => {
            if (caller === 'add-member') {
                /* Extra () needed to return map object with properties instead of value */
                const newItems = selectItems.filter(i => i.isSelected === true)
                    .map(i => ({ memberID: i.id, isLeader: false }));

                await saveGroupMembersAsync(
                    {
                        btnId: '#btnSave',
                        data: { groupID: groupID, leaderStatuses: newItems },
                        divErrMsg: 'divSearchDlgErrMsg'
                    }).then(async () => {
                       const members =   await getGroupMembersAsync({ groupID })
                       refreshGroupMembersGrid({ members });
                        $('#searchDlg').modal('hide');
                    })

            }
            else if (caller === 'add-leader') {
                /* Extra () needed to return map object with properties instead of value */
                const newItems = selectItems.filter(i => i.isSelected === true)
                    .map(i => ({ memberID: i.id, isLeader: true }));
                groupLeadersToAdd = { groupID: groupID, leaderStatuses: newItems };
                refreshGroupLeadersGrid({ groupID });
                $('#searchDlg').modal('hide');
            }
        });
    });
}

const initUpdateDlg = () => {

    $('#updateDlg input[id!="editGroupImg"]').on('change', () => setModified(true));

    $('#editName').on('input', (e) => {
        $('#grpPreviewDesc').text($('#editName').val());
        setModified(true);
    });

    initImgCtrl({
        inputFileCtrl: '#editGroupImg',
        imgCtrl: '#imgGroup'
    });

    $('#ddlAccess').on('change', setJoinRequestVisibility);

    $('#updateDlg').on('show.bs.modal', async (e) => {
        const key = e.relatedTarget.dataset.key;
        $('#hiddenID').val(key);

        groupLeadersToAdd = [];
        groupLeadersToRemove = [];

        if (key === '-1') {
            setUpdateCtrlsForNewGroup()
        } else if (key === '0') { /* Get data for default church group */
            try {
                const d = await getChurchGroupData();   
                setUpdateCtrlsForBaseGroupData(d);
                refreshGroupLeadersGrid({ groupID: '0' });
            }
            catch (error) { }
        } else { /* Get data for church defined group */
            groupID = key;
            try {
                const d = await getGroupDataAsync({ groupID });
                setUpdateCtrlsForGroup(d);
            }
            catch (error) { }
            refreshGroupLeadersGrid({ groupID });
        }
        setDefinedGroupVisibility({ isVisible: key !== '0' });

    });

    $('#btnSave').on('click', async () => await saveGroupAsync({ btnId: '#btnSave' }));

}

const refreshGroupLeadersGrid = (params) => {

    const currentGroupLeaders = getCurrentGroupLeaders(params.groupID).sort((a, b) =>
        a.lastName.localeCompare(b.lastName) ||
        a.firstName.localeCompare(b.firstName));

    getTableRows({
        arr: currentGroupLeaders,
        fnGetRow: getGroupLeaderRow,
        gridNm: 'gridLeaders'
    });
}

const refreshGroupMembersGrid = (params) =>
    getTableRows({ arr: params.members, fnGetRow: getGroupMemberRow, gridNm: 'gridList' });


const refreshGroupsGrid = () => {
    setBtnRestoreGroupVisibility();
    //console.log('groups',groups);
    getTableRows({ arr: groups, fnGetRow: getGroupRow, gridNm: 'gridGroups' });
    $('#gridGroups .grpImg').off('error').on('error', (e) => {
        e.target.src = `${testFolderImgsBaseURL}${e.target.dataset.img_name}`;
    });
    let joinRequestsDlgInitialized = false;
    for (let i = 0, l = groups.length; i < l; i++) {
        if (groups[i].access === 1 && joinRequestsDlgInitialized === false) {
            /* Initialize if there is at least one private group */
            initJoinRequestDlg();
            joinRequestsDlgInitialized = true;
            break;
        }
    }
}

const refreshJoinRequestGrid = (params) =>
    getTableRows({ arr: params.data, fnGetRow: getJoinRequestRow, gridNm: 'gridJoinRequests' });

const restoreGroupAsync = async (params) => {
    await savePromise({
        url: 'Groups/Restore',
        data: {
            cg: token.CG,
            id: params.groupID
        },
        divErrMsg: 'divDelDlgErrMsg'
    }).then(() => {
        /* splice returns array of deleted elements so we take first and only one [0] */
        let g = deletedGroups.splice(deletedGroups.findIndex(x => x.id === params.groupID), 1)[0];
        g.daysBeforeDeletion = -1;
        groups.push(g);
        groups.sort((a, b) => { a.DisplayOrder - b.DisplayOrder }); /* negative puts a first else b */
        refreshGroupsGrid();
        $('#ddlDlg').modal('hide');
    })
}

const saveGroupAsync = async (params) => {

    const saveChurchGroupDataAsync = async () => {
        await savePromise({
            url: 'Churches/Group',
            data: {
                cg: token.CG,
                name: $('#editName').val(),
                imgName: $('#hiddenImgName').val(),
            },
            btnId: params.btnId,
            divErrMsg: 'divUpdDlgErrMsg'
        }).then(async () => await updateGroupsArrayAsync());
    }
    const saveGroupDataAsync = async () => {
        const groupID = $('#hiddenID').val(),
            $maxMembers = $('#editMaxMembers').val();

        await savePromise({
            url: 'Groups',
            data: {
                id: groupID,
                cg: token.CG,
                name: $('#editName').val(),
                imgsFolder: $('#hiddenImgsFolder').val(), 
                imgName: $('#hiddenImgName').val(),
                access: $('#ddlAccess').val(),
                description: $('#editDescription').val(),
                maxMembers: $maxMembers.length > 0 ? parseInt($maxMembers, 10) : null,
                enableJoinRequestNotifications: $('#cbEnableJoinRequestNotifications').is(':checked'),
                enableAnnouncements: $('#cbEnableAnnouncements').is(':checked'),
                enableEvents: $('#cbEnableEvents').is(':checked'),
                enablePrayers: $('#cbEnablePrayers').is(':checked'),
                enableSermons: $('#cbEnableSermons').is(':checked')
            },
            divErrMsg: 'divUpdDlgErrMsg'
        })
            .then(async (data) => {
                const promises = [];
                if (groupLeadersToRemove.length > 0) {
                    groupLeadersToRemove.forEach(glToRemove => {
                        if (groupLeadersToAdd.hasOwnProperty('leaderStatuses')) {
                            const idx =
                                groupLeadersToAdd.leaderStatuses.findIndex(x => x.memberID === glToRemove.memberID);
                            if (idx > -1) {

                                /* leaders was added - then removed on page before being saved  *
                                 * remove from addition object and removal array so database is *
                                 * not updated...                                               */

                                groupLeadersToAdd.LeaderStatuses.splice(idx, 1);
                                groupLeadersToRemove.splice(
                                    groupLeadersToRemove.findIndex(x => x.memberID === glToRemove.memberID),
                                    1
                                )
                            }
                        }

                    });
                    if (groupLeadersToRemove.length > 0) {
                        groupLeadersToRemove.forEach(glToRemove => {
                            /* Remove existing group leaders */
                            promises.push(
                                saveGroupLeaderAsync({
                                    groupID,
                                    memberID: glToRemove.memberID,
                                    isLeader: false
                                }))
                        });
                    }
                }
                /* Save remaining new group leaders */
                if (groupLeadersToAdd.hasOwnProperty('leaderStatuses') &&
                    groupLeadersToAdd.leaderStatuses.length > 0) {
                    groupLeadersToAdd.leaderStatuses.forEach(glToAdd => {
                        promises.push(
                            saveGroupLeaderAsync({
                                groupID: data,
                                memberID: glToAdd.memberID,
                                isLeader: true
                            }))

                    })
                }

                //Promise.all(promises).then(() => { setTimeout(postSave, 100); });

                await allSettled({ promises: promises })
                    .then(async () => {
                        //await updateGroupsArrayAsync();
                        const [
                            groupsData,
                            gLeaders,
                        ] =
                            await allSettled({
                                promises: [
                                    getGroupsDataAsync(),
                                    getGroupLeadersAsync()
                                ]
                            });

                        if (groupsData.status !== 'rejected') {
                            const allGroups = groupsData.value;
                            groups = allGroups.filter(x => x.daysBeforeDeletion === -1);
                            deletedGroups = allGroups.filter(x => x.daysBeforeDeletion > -1);
                        };
                        if (gLeaders.status !== 'rejected') {
                            groupLeaders = gLeaders.value;
                        };
                        refreshGroupsGrid();
                        groupLeadersToAdd = [];
                        groupLeadersToRemove = [];
                        $('#updateDlg').modal('hide');
                    });
            });
    }

    const updateGroupsArrayAsync = async () => {
        $('#updateDlg').modal('hide');

        /* update groups array properties and refresh grid */

        const idx = groups.findIndex(x => x.id === groupID);
        if (idx > -1) {
            groups[idx].name = $('#editName').val();
            groups[idx].imgsFolder = $('#hiddenImgsFolder').val();
            groups[idx].imgName = $('#hiddenImgName').val();
            refreshGroupsGrid();
        }
        else {
            try {
                groups = await getGroupsDataAsync()
                refreshGroupsGrid();
            }
            catch (error) { }
        }
    }

    const saveDataAsync = async () => {
        if ($('#hiddenID').val() === "0") { await saveChurchGroupDataAsync() } else { await saveGroupDataAsync(); }
    }

    if (missingRequiredData({
        dataItems: [
            { ctrlNm: '#editName', labelText: 'Name' }
        ]
    })) return;

    document.getElementById("loader").style.display = "block";

    if (hasImgsToUpload()) {
        await uploadImgToCloudAsync({
            divErrMsg: 'divUpdDlgErrMsg',
            imgsFolder: ImgsFolder.Groups,
            imgCtrl: '#imgGroup',
            imgName: $('#hiddenImgName').val(),
            addEncircledImage: true,
            addThumbNail: true,
            saveAsJPEG: false,
            url: 'Storage/Img',
            useTestFolder: useTestFolder,
            postOnload: async (returnParams) => {
                $('#hiddenImgName').val(returnParams.data);
                await saveDataAsync();
            }
        });

    } else {
        await saveDataAsync();
    }
}

const setUpdateCtrlsForBaseGroupData = (data) => {
    $('#updateDlgLbl').text(`Editing ${data.name}...`);
    $('#editName').val(data.name);
    $('#grpPreviewDesc').text(data.name);
    if (data.imgName.length > 0) {
        groupImgName = data.imgName;
        $('#hiddenImgName').val(groupImgName);
        $('#imgGroup').prop('src', groupImgsBaseURL + groupImgName);
    }
}
const setUpdateCtrlsForGroup = (data) => {
    setUpdateCtrlsForBaseGroupData(data);
    $('#ddlAccess').val(data.access);
    $('#editDescription').val(data.description);
    if (data.maxMembers !== null) {
        $('#editMaxMembers').val(data.maxMembers);
    }
    $('#cbEnableJoinRequestNotifications').prop('checked', data.enableJoinRequestNotifications);
    $('#cbEnableAnnouncements').prop('checked', data.enableAnnouncements);
    $('#cbEnableEvents').prop('checked', data.enableEvents);
    $('#cbEnablePrayers').prop('checked', data.enablePrayers);
    $('#cbEnableSermons').prop('checked', data.enableSermons);
    setJoinRequestVisibility();
}
const setUpdateCtrlsForNewGroup = () => {
    $('#updateDlgLbl').text('Adding group...');
    $('#hiddenID').val('-1');
    $('#editName').val('');
    $('#hiddenImgName').val('');
    $('#ddlAccess').val('0');
    $('#editMaxMembers').val('');
    $('#editDescription').val('');
    $('#imgGroup').prop('src', groupImgsBaseURL + groupDefaultImgNm);
    $('#cbEnableJoinRequestNotifications').prop('checked', false);
    $('#cbEnableAnnouncements').prop('checked', false);
    $('#cbEnableEvents').prop('checked', false);
    $('#cbEnablePrayers').prop('checked', false);
    $('#cbEnableSermons').prop('checked', false);
    $('#gridLeaders tbody').empty()
}
const setDefinedGroupVisibility = (params) => {
    (params.isVisible === undefined || params.isVisible === true)
        ? $('.defined-group').removeClass('hidden')
        : $('.defined-group').addClass('hidden');
}
const setJoinRequestVisibility = () => {
    $('#ddlAccess').val() !== '1'
        ? $('#divEnableJoinRequestNotifications').addClass('hidden')
        : $('#divEnableJoinRequestNotifications').removeClass('hidden');
}
const setBtnRestoreGroupVisibility = () => {
    (deletedGroups.length > 0)
        ? $('#btnRestoreGroup').removeClass('hidden')
        : $('#btnRestoreGroup').addClass('hidden');
}

let churchMembers = [];
let deletedGroups = [];
//let groupMembers = [];
let groupLeaders = [];
let groupLeadersToAdd = [];
let groupLeadersToRemove = [];
let groups = [];
let groupID = 0;
let groupDefaultImgNm = "";
let groupImgsBaseURL = "";
let groupImgName = "";
let hasGroups = false;
let memberImgsBaseURL = "";
let testFolderImgsBaseURL = "";

/* public functions */

const getGroupIDsFromRights = (params = {}) => {
    const { rights } = params;
    if (!rights) {
        alert('rights parameter required for getgroupIDsCVSFromRights')
        return;
    }
    /* get groupIDs from rights string with the following format
     * groupID ^ FeatureID [| FeatureID] , groupID ^ FeatureID [| FeatureID] } */
    const groupIDs = [];
    const groupsData = params.rights.split(',');
    groupsData.forEach(g => groupIDs.push(g.split('^')[0]));
    return (params.asCSV !== undefined && params.asCSV === true)
        ? groupIDs.join(',')
        : groupIDs;
}

const initAsync = async () => {
    window.onbeforeunload = () => {
        if (isDataModified() === true) {
            return "Your changes have not been saved...";
        }
    };
    setMenu();

    //$('#groupsGrid .groupImg').off('error').on('error', (e) => { console.log('img error', e); e.target.src = groupImgsBaseURL + groupDefaultImgNm; });

    const [cMembers,
        accessLevels,
        gDfltImgNm,
        gImgsBaseURL,
        mImgsBaseURL,
        groupsData,
        gLeaders,
        tImgsBaseURL
    ] =
        await allSettled({
            promises: [getMemberSearchDataAsync(),
            getGroupAccessLevelsDDLDataAsync(),
            getGroupDefaultImgNmAsync(),
            getImgsBaseURLAsync(ImgsFolder.Groups),
            getMemberImgsBaseURLAsync(),
            getGroupsDataAsync(),
            getGroupLeadersAsync(),
            getImgsBaseURLAsync(ImgsFolder.TestFolder),
            ]
        });

    if (cMembers.status !== 'rejected') {
        churchMembers = cMembers.value;
    };

    if (accessLevels.status !== 'rejected') {
        bindSelect({ id: 'ddlAccess', items: accessLevels.value });
    };

    if (gDfltImgNm.status !== 'rejected') {
        groupDefaultImgNm = gDfltImgNm.value;
    };
    if (gImgsBaseURL.status !== 'rejected') {
        groupImgsBaseURL = gImgsBaseURL.value;
    };
    if (mImgsBaseURL.status !== 'rejected') {
        memberImgsBaseURL = mImgsBaseURL.value;
    };
    if (groupsData.status !== 'rejected') {
        const allGroups = groupsData.value;
        groups = allGroups.filter(x => x.daysBeforeDeletion === -1);
        deletedGroups = allGroups.filter(x => x.daysBeforeDeletion > -1);
    };
    if (gLeaders.status !== 'rejected') {
        groupLeaders = gLeaders.value;
    };
    if (tImgsBaseURL.status !== 'rejected') {
        testFolderImgsBaseURL = tImgsBaseURL.value;
    };
    refreshGroupsGrid();

    initConfirmDlg();
    initDeleteDlg();
    initDlg_DDL();
    initMembersDlg();
    initSearchDlg();
    initUpdateDlg();

    initDragDropTableSort({
        selector: '#gridGroups > tbody',
        items: '>tr:not(".no-sort")',
        fnStop: async () => {
            await savePromise({
                url: 'Groups/Sort',
                data: getSortKeysFromTableOrder({
                    selector: '#gridGroups > tbody > tr:not(".no-sort")'
                })
            })
        }
    });

    $('#editGroupName').on('input', (e) => {
        $('#grpPreviewDesc').text($('#editGroupName').val());
        setModified(true);
    });
    $('#imgGroup').off('error').on('error', (e) => {
        e.target.src = testFolderImgsBaseURL + groupImgName;
    });
};

const initGroupsAsync = async (params = {}) => {    

    const [gImgsBaseURL, toolBarData, tImgsBaseURL] =
        await allSettled({
            promises: [
                getImgsBaseURLAsync(ImgsFolder.Groups),
                getGroupsToolBarDataAsync(params),
                getImgsBaseURLAsync(ImgsFolder.TestFolder),
            ]
        });

    if (gImgsBaseURL.status !== 'rejected' &&
        toolBarData.status !== 'rejected' &&
        tImgsBaseURL.status !== 'rejected') {

        const {
            useDDL,
            useToolBar
        } = params;

        groupImgsBaseURL = gImgsBaseURL.value;
        hasGroups = toolBarData.value.hasGroups;
        groups = toolBarData.value.groups;
        testFolderImgsBaseURL = tImgsBaseURL.value;

        const groupsQueryParam = token.IsAdmin === "True"
            ? getGroupsQueryParam()
            : getGroupsQueryParam({
                groups: groups,
                queryOperator: params.queryOperator
            });

        if (useToolBar === true) {
            initGroupsToolBar({
                showFilter: params.showFilter !== undefined && params.showFilter === true,
                groups,
                hasGroups,
                fnToolBarGroupDDLClick: params.fnToolBarGroupDDLClick
            })
        }
        if (useDDL === true) {
            initGroupsDDL({
                groupID: params.groupID,
                groups,
                fnGroupDDLClick: params.fnGroupDDLClick
            });
        }
        return {
            groupImgsBaseURL,
            groupsQueryParam,
            groups,
            hasGroups,
            testFolderImgsBaseURL
        }
    }
}


export {
    getGroupIDsFromRights,
    getGroupsQueryParam,
    groups,
    groupImgsBaseURL,
    hasGroups,
    initGroupsAsync
};

window.snGroups = {
    initAsync
};